import { humanize } from './format'

export const enumToOptions = <T extends string>(
  data: Record<string, T>,
  formatter = humanize,
) =>
  Object.entries(data).map(([key, value]) => ({
    value,
    key,
    label: formatter(value),
  }))
